import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faClipboardList } from '@fortawesome/pro-solid-svg-icons';
import AssignmentTypes from '../../../enums/assignmentTypes';

export const colorCode = [
  {
    id: 1,
    name: 'Not Scored',
    label: 'NS',
    backgroundColor: '#FFEDED',
    icon: <span className='circleBtn d-flex justify-content-center align-items-center' style={{ color: '#FF0404'}}>NS</span>
  },
  {
    id: 2,
    name: 'Not Started',
    label: 'N',
    backgroundColor: '#FCEAFF',
    icon: <span className='circleBtn d-flex justify-content-center align-items-center' style={{ color: '#C637DD'}}>N</span>
  },
  {
    id: 3,
    name: 'In Progress',
    label: 'P',
    backgroundColor: '#FFF0DE',
    icon: <span className='circleBtn d-flex justify-content-center align-items-center' style={{ color: '#F7931E'}}>P</span>
  }
];

export const AssignmentFilterTypes = [
  {
    id : 1,
    name : 'Assignment',
    color : '#52C9A5',
    type : AssignmentTypes.Assignment,
    icon : <FontAwesomeIcon icon={faBook} color='white' className='fs-6 m-0' />
  },
  {
    id : 2,
    name : 'Assessment',
    color : '#ED279E',
    type : AssignmentTypes.Assessment,
    icon: <FontAwesomeIcon icon={faClipboardList} color='white' className='fs-6 m-0' />
  }
];